import i18n_ from './i18n_';
import strings_en from './localisedStrings.en.js';
import strings_de from './localisedStrings.de.js';

const { localiser, localiser: { loc } } = i18n_;

const strings = {
	en: strings_en,
	de: strings_de
};

const lang = localiser.getCurrentLanguage();

loc.strings = strings[lang];
lang !== 'en' && (loc.strings_en = strings_en);	// for fallback

export default localiser;


// WEBPACK FOOTER //
// ./src/i18n/i18n.js